import { getAllBlogPosts, getBlogData, logAction } from '../../services/api';

export async function fetchBlogPosts() {
  return getAllBlogPosts();
}

export async function fetchBlogPost(urlId) {
  return getBlogData(urlId);
}

export function logBlogListView() {
  logAction('VIEW_PUBLIC_BLOG_LIST');
}

export function logBlogPostView(urlId) {
  logAction('VIEW_BLOG_POST', urlId);
}
